import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-wordmark',
  templateUrl: './icon-wordmark.component.html',
  styleUrls: ['./icon-wordmark.component.scss'],
  standalone: true,
})
export class IconWordmarkComponent {
  @Input() color = '#fff';
  @Input() width = '113.8';
  @Input() height = '28.18';
}
